import { ILgpHero, LgpHero } from "@sky-it-livedata/livedata-sports-design-system";
import { graphql } from "appsync";

import transformQuery from "./transformers/query-transformer";
import transformSubscription from "./transformers/subscription-transformer";
import { LgpHeroQuery, LgpHeroSubscription } from "./types";
import { log } from "../../utils/log";
import { useSubscription } from "../../hooks/useSubscription";
import { WidgetContext } from "../../types/WidgetContext";

export const setCustomAttributes = ({variables}: WidgetContext<LgpHeroQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
}

const subscriptionDocument = graphql("subscription UpdateLgpHeroWidget($seasonAndCompId: ID!, $gpId: ID!) {\n  onUpdateLgpHeroWidgetBySeasonAndCompIdAndGpId(\n    seasonAndCompId: $seasonAndCompId\n    gpId: $gpId\n  ) {\n    gpId\n    session {\n      label\n      name\n      status\n      podium {\n        customDriverName\n        customDriverSurname\n        customDriverShortName\n        driverImgUrl\n        flagImgUrl\n        position\n      }\n    }\n    info {\n      circuitImgUrl\n      customGpName\n      flagImgUrl\n      startDate\n      sportTag\n      endDate\n    }\n    seasonAndCompId\n  }\n}");

export function getServerProps({
  props,
}: WidgetContext<LgpHeroQuery>): ILgpHero {
  return transformQuery(props);
}

const LgpHeroWidget = ({props,
  variables,
  ...rest
}: WidgetContext<ILgpHero>) => {
  log({ props, variables, ...rest });

  const updatedProps = useSubscription<
    ILgpHero,
    LgpHeroSubscription,
    typeof subscriptionDocument
  >({
    initialData: props,
    graphQLDocument: subscriptionDocument,
    variables,
    transform: transformSubscription,
    mergeData: false,
  }) as ILgpHero;

  return <LgpHero {...updatedProps}/>;
}

export default LgpHeroWidget;